/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-05-19 17:21:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-05-28 15:12:35
 * @FilePath: /miaobi-app-h5/src/main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './styles/global.css';
import App from './App.vue';
import router from './router';
// eruda
import eruda from 'eruda';
const app = createApp(App);
const pinia = createPinia();
if (import.meta.env.VITE_APP_ENV !== 'live') {
  eruda.init();
}
app.use(pinia);
app.use(router);
app.mount('#app');
